import {
    formatCalendarCellDate,
    formatDateString,
    getWeekKeyFromDate,
} from "./calendarMonthUtils";

export function getBookingForDate(bookingDateStr, weekData = {}, bookingSpotData = []) {
    const weekMatch = Object.values(weekData || {})
        .flat()
        .find((booking) => booking.BookingDate === bookingDateStr);

    return weekMatch || (bookingSpotData || []).find((booking) => booking.BookingDate === bookingDateStr) || null;
}

export function resolveDayCellState({
    date,
    selectedDate,
    weekData = {},
    bookingSpotData = [],
    today = new Date(),
}) {
    const currentDate = date;
    const cellDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const currentDateString = formatCalendarCellDate(currentDate);
    const isSelected = currentDateString === selectedDate;

    const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const cellDateMidnight = new Date(cellDate.getFullYear(), cellDate.getMonth(), cellDate.getDate());
    const isPastDate = cellDateMidnight < todayMidnight;

    const weekKey = getWeekKeyFromDate(currentDate);
    const currentWeekMonday = new Date(todayMidnight);
    const currentWeekDay = currentWeekMonday.getDay();
    const currentWeekDiff = currentWeekMonday.getDate() - currentWeekDay + (currentWeekDay === 0 ? -6 : 1);
    currentWeekMonday.setDate(currentWeekDiff);
    currentWeekMonday.setHours(0, 0, 0, 0);

    const mondayOfWeek = new Date(cellDate);
    const dayOfWeek = mondayOfWeek.getDay();
    const diff = mondayOfWeek.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
    mondayOfWeek.setDate(diff);
    mondayOfWeek.setHours(0, 0, 0, 0);

    const isCurrentWeek = currentWeekMonday.getTime() === mondayOfWeek.getTime();
    const hasFetchedData = Object.prototype.hasOwnProperty.call(weekData, weekKey);

    const monthWeekBookings = (bookingSpotData || []).filter(
        (booking) => getWeekKeyFromDate(booking?.BookingDate) === weekKey
    );

    const weekBookings = (hasFetchedData || isCurrentWeek)
        ? (weekData[weekKey] || monthWeekBookings)
        : monthWeekBookings;

    const boundaryBookingOnDate = monthWeekBookings.find((booking) => {
        const bookingDate = formatDateString(booking.BookingDate);
        return (
            bookingDate &&
            bookingDate.getFullYear() === cellDate.getFullYear() &&
            bookingDate.getMonth() === cellDate.getMonth() &&
            bookingDate.getDate() === cellDate.getDate()
        );
    });

    const isBoundaryDisabledDate =
        Number(boundaryBookingOnDate?.CurrentMonth) === 0 &&
        Number(boundaryBookingOnDate?.ActiveMonth) === 0;

    const bookingOnDate = (hasFetchedData || isCurrentWeek)
        ? weekBookings.find((booking) => {
            const bookingDate = formatDateString(booking.BookingDate);
            return (
                bookingDate &&
                bookingDate.getFullYear() === cellDate.getFullYear() &&
                bookingDate.getMonth() === cellDate.getMonth() &&
                bookingDate.getDate() === cellDate.getDate()
            );
        })
        : isBoundaryDisabledDate
            ? boundaryBookingOnDate
            : undefined;

    return {
        bookingOnDate,
        cellDate,
        currentDateString,
        dateNumber: currentDate.getDate(),
        hasFetchedData,
        isBoundaryDisabledDate,
        isCurrentWeek,
        isPastDate,
        isSelected,
        monthWeekBookings,
        weekBookings,
        weekKey,
    };
}
